import React from "react";
import { Product } from "components/glamclub/Product";
import { Helmet } from "react-helmet";

export const Produto = ({ match, location, history }) => {
  if (
    !match.params.productId 
    && !match.params.productVariantId 
    && !match.params.productVariantName
  ) {
    history.push("/produtos");
  }

  return (
    <div className={"p-2 p-lg-5"}>  
      <Helmet>
        <title>Minha Glambox : Produto</title>
      </Helmet>
    
      <Product productId={match.params.productId}
               productVariantId={match.params.productVariantId} 
               productVariantName={match.params.productVariantName} 
               history={history}>
      </Product>
    </div>
  )
}